{
  "tabs": {
    "chat": "ውይይት",
    "reminders": "አስታውሶች",
    "calendar": "የቀን መቁጠሪያ",
    "settings": "ቅንብሮች"
  },
  "common": {
    "cancel": "ሰርዝ",
    "save": "አስቀምጥ",
    "confirm": "አረጋግጥ",
    "delete": "ሰርዝ",
    "back": "ተመለስ",
    "close": "ዝጋ",
    "edit": "አርትዕ",
    "search": "ፈልግ",
    "all": "ሁሉ",
    "loading": "በመጫን ላይ...",
    "error": "አንድ ስህተት ተከሰተ",
    "notFound": "አልተገኘም",
    "tryAgain": "እባክዎ እንደገና ይሞክሩ",
    "retry": "እንደገና ሞክር",
    "undo": "አስተካክል",
    "pullToRefresh": "ለማደስ ሽንት አውርድ",
    "justNow": "አሁን ብቻ"
  },
  "auth": {
    "welcome": "እንኳን ወደ FishMemory በደህና መጡ",
    "tagline": "የ WhatsApp አስታውሰኛ አገልጋይዎ፣ አሁን በእጅዎ ውስጥ።",
    "subtitle": "የ WhatsApp አስታውሰኛ አገልጋይዎ፣ አሁን በእጅዎ ውስጥ።",
    "phoneLabel": "የ WhatsApp ቁጥርዎ",
    "phoneHint": "እኛ በ WhatsApp የማረጋገጫ ኮድ እንልክላችኋለን",
    "invalidPhone": "እባክዎ ትክክለኛ የስልክ ቁጥር ያስገቡ",
    "continue": "ቀጥል",
    "enterPhone": "የ WhatsApp ቁጥርዎን ያስገቡ",
    "phonePlaceholder": "የስልክ ቁጥር",
    "sendCode": "ኮድ ላክ",
    "verifyTitle": "ቁጥርዎን ያረጋግጡ",
    "otpSentTo": "6 ቁጥር ኮድ በ WhatsApp ወደ {{phone}} ተልኳል",
    "enterFullCode": "እባክዎ ሁሉንም 6 ቁጥሮች ያስገቡ",
    "invalidOtp": "የተሳሳተ ኮድ። እባክዎ እንደገና ይሞክሩ።",
    "otpFailed": "ኮድ ማስተላለፊያ አልተሳካም። እንደገና ይሞክሩ።",
    "otpResent": "ኮድ ተመላሽ ተልኳል",
    "resendIn": "በ {{seconds}} ሰከንዶች ውስጥ ድገም ላክ",
    "resendCode": "ኮድ ድገም ላክ",
    "enterOtp": "ወደ WhatsApp የተላከውን ኮድ ያስገቡ",
    "verify": "አረጋግጥ",
    "resend": "ኮድ ድገም ላክ",
    "wrongNumber": "ቁጥር ትክክል አይደለም?",
    "backToPhone": "ወደ ስልክ ተመለስ",
    "editPhone": "የስልክ ቁጥር አርትዕ",
    "error": "ስህተት",
    "setupTitle": "እንደገና እንዘጋጅ",
    "setupSubtitle": "እነዚህን በቅንብሮች ውስጥ በኋላ ማስተካከል ይችላሉ",
    "namePlaceholder": "ስምዎ",
    "letsGo": "እንዘጋጅ",
    "skipForNow": "አሁን ይዘው ይተዉ"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "መልእክት ያስገቡ...",
    "inputPlaceholder": "መልእክት ያስገቡ...",
    "typing": "FishMemory በመጻፍ ላይ ነው...",
    "online": "መስመር ላይ",
    "connecting": "በመገናኘት ላይ...",
    "reconnecting": "እንደገና በመገናኘት ላይ...",
    "offline": "መስመር ላይ አይደለም",
    "empty": "ውይይት ጀምር",
    "emptyHint": "አስታውሶችን ፍጠር፣ ጊዜ ሰሌዳህን ተመልከት ወይም እርዳታ ጠይቅ።",
    "emptyAction": "ናሙና አስታውስ ላክ",
    "actions": "የውይይት እርምጃዎች",
    "keep": "መልእክቶችን አስቀምጥ",
    "clearTitle": "ውይይት አጽዳ",
    "clearConfirm": "ከዚህ መሣሪያ ሁሉንም መልእክቶች ሰርዝ? ይህ አይተካልም።",
    "clear": "ውይይት አጽዳ",
    "optionSelected": "ተመርጧል: {{label}}",
    "sendingSelection": "በመላክ ላይ...",
    "connectionLost": "እንደገና በመገናኘት ላይ..."
  },
  "reminders": {
    "title": "እኔ ያስታውሳሉ",
    "active": "እየሰራ",
    "today": "ዛሬ",
    "thisWeek": "ይህ ሳምንት",
    "history": "ታሪክ",
    "items": "ንጥሎች",
    "emptyTitle": "አሁንም አስታውሶች የሉም",
    "emptySubtitle": "ከውይይት አንዱን ፍጠር እና እዚህ ይታያል።",
    "emptyAction": "ውይይት ክፈት",
    "filterActive": "እየሰራ",
    "filterToday": "ዛሬ",
    "filterWeek": "ይህ ሳምንት",
    "filterHistory": "ታሪክ",
    "emptyState": "አሁንም አስታውሶች የሉም። ውይይት ጀምር!",
    "swipeDone": "ተጠናቀቀ",
    "swipeSnooze": "አስቆም",
    "swipeDelete": "ሰርዝ",
    "search": "አስታውሶችን ፈልግ...",
    "upcoming": "ቀርቦ ያለ",
    "completed": "ተጠናቀቀ",
    "overdue": "ያልተጠናቀቀ",
    "tomorrow": "ነገ",
    "synced": "ተዛመደ {{value}}",
    "swipeHint": "ለተጨማሪ እርምጃዎች አስታውስ አንድ ጫን አድርግ",
    "noResults": "የፈለጉት አስታውሶች አልተገኙም",
    "noResultsHint": "ሌላ ቁልፍ ቃል ይሞክሩ ወይም ፍለጋውን አጽዳ",
    "deleteAllFailed": "ሁሉንም አስታውሶች ማስወገድ አልተሳካም"
  },
  "calendar": {
    "title": "የቀን መቁጠሪያ",
    "today": "ዛሬ",
    "tomorrow": "ነገ",
    "completed": "ተጠናቀቀ",
    "noEvents": "ምንም እቅድ የለም",
    "noEventsSubtitle": "እባክዎ ቀን ይምረጡ ለማየት አስታውሶችን እና የቀን መቁጠሪያ ክስተቶችን።",
    "googleEvent": "Google Calendar",
    "legendActive": "እየሰራ",
    "legendRecurring": "የሚደገም",
    "legendDone": "ተጠናቀቀ",
    "legendGoogle": "Google",
    "previousMonth": "ያለፈው ወር",
    "nextMonth": "ቀጣይ ወር",
    "previousYear": "ያለፈው አመት",
    "nextYear": "ቀጣይ አመት",
    "goToToday": "ወደ ዛሬ ሂድ",
    "all": "ሁሉ",
    "active": "እየሰራ",
    "done": "ተጠናቀቀ",
    "paused": "ቆሟል"
  },
  "settings": {
    "title": "ቅንብሮች",
    "profile": "መገለጫ",
    "name": "የሚታይ ስም",
    "enterName": "ስምዎን ያስገቡ",
    "language": "ቋንቋ",
    "uiLanguage": "የመተግበሪያ ቋንቋ",
    "uiLanguageHelp": "ይህ በዚህ መሣሪያ ላይ የመተግበሪያ አገልግሎት፣ የቀን መቁጠሪያ መለኪያዎችን እና የአውታረ ቅርጸ ተንቀሳቃሽነት ይቀይራል።",
    "serverLanguage": "የውይይት ቋንቋ",
    "serverLanguageHelp": "ለአካውንትዎ የአገልግሎት መስመር መልስና የአስታውስ መልእክቶች ቋንቋ ይቀይራል።",
    "timezone": "የሰዓት ክልል",
    "currentTimezone": "የአሁኑ የሰዓት ክልል",
    "timezoneHelp": "ሁሉም የአስታውስ ሰዓታት በዚህ የሰዓት ክልል ይታያሉ።",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "የሰዓት ክልል አስቀምጥ",
    "timezoneSaved": "የሰዓት ክልል ተሻሽሏል",
    "detect": "አስማት",
    "detectFailed": "የሰዓት ክልል ማስለት አልተሳካም",
    "autoDetect": "ከ GPS በራስ አስማት",
    "notifications": "ማስታወቂያዎች",
    "notificationsHelp": "የተከታታይ አስታውሶች ከአስታውስ ከተላከ በኋላ የተደጋጋሚ ማስታወቂያዎችን ይቆጣጠራሉ። የመሣሪያ ደረጃ ማስታወቂያ ፈቃዶች እንደገና በስልክዎ ቅንብሮች ይተገበራሉ።",
    "pushEnabled": "የጥሪ ማስታወቂያዎች",
    "autoDoneOnFire": "በማብሰል ራስሰር አስታውስን ያስመዝግብ",
    "autoDoneOnFireDesc": "ከተጠናቀቀ ከሆነ አስታውሶች እስከ እርስዎ እንደተጠናቀቁ ድረስ እየተነሱ ይቀራሉ።",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "ተገናኝቷል",
    "googleDisconnected": "አልተገናኘም",
    "googleConnectedHelp": "አዲስ አስታውሶች በራስሰር ወደ የቀን መቁጠሪያዎ ሊዛመዱ ይችላሉ።",
    "googleDisconnectedHelp": "Google Calendar ይገናኙ እንዲሁም አስታውሶችን እና ክስተቶችን በተስማሚ ሁኔታ ያዘጋጁ።",
    "googleConnectFailed": "Google Calendar ማገናኘት አልተሳካም",
    "connected": "ተገናኝቷል",
    "disconnected": "አልተገናኘም",
    "connect": "ገናኝ",
    "disconnect": "ተለይ",
    "autoSync": "አዲስ አስታውሶች በራስሰር ዛመድ",
    "autosync": "አዲስ አስታውሶች በራስሰር ዛመድ",
    "subscription": "ምዝገባ",
    "trialUsed": "ሙከራ: {{used}}/{{total}} ተጠቀም",
    "trialStatus": "ሙከራ አለ",
    "activeStatus": "እየሰራ ያለ ምዝገባ",
    "expiredStatus": "ምዝገባ ያልተጠበቀ",
    "unsubscribedStatus": "አልተመዘገበም",
    "about": "ስለ እኛ",
    "version": "እትም",
    "logout": "ውጣ",
    "logoutTitle": "ውጣ",
    "logoutConfirm": "እርግጠኛ ነህ ለመውጣት?",
    "noName": "ስም አልተሰጠም",
    "serverConnection": "የአገልግሎት መገናኛ",
    "serverUrl": "የአገልግሎት አድራሻ",
    "serverEdit": "አርትዕ",
    "saveReconnect": "አስቀምጥ እና እንደገና ገናኝ",
    "resetDefault": "ነባሪ እንደገና ማድረግ",
    "invalidServerUrlTitle": "የተሳሳተ የአገልግሎት አድራሻ",
    "invalidServerUrlMessage": "ትክክለኛ የ http ወይም https የአገልግሎት አድራሻ ያስገቡ፣ ለምሳሌ https://example.com",
    "uiLanguageChangeFailed": "የመተግበሪያ ቋንቋ መቀየር አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    "serverLanguageChangeFailed": "የውይይት ቋንቋ መቀየር አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    "timezoneChangeFailed": "የሰዓት ክልል መቀየር አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    "autoSyncChangeFailed": "የራስሰር ዛመድ ማሻሻያ አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    "nameChangeFailed": "የሚታይ ስም ማሻሻያ አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "የአስታውስ ዝርዝሮች",
    "editTime": "ሰዓት አርትዕ",
    "rename": "ስም ቀይር",
    "snooze": "አስቆም",
    "snooze15": "15 ደቂቃ አስቆም",
    "pause": "ቆም",
    "pauseReminder": "አስታውስ አቆም",
    "resume": "እንደገና ጀምር",
    "resumeReminder": "አስታውስ እንደገና ጀምር",
    "skip": "ቀጣይ ይዘው ይዘው ይዘው",
    "skipOccurrence": "ይህን ክስተት ተው",
    "syncGoogle": "ወደ Google ዛመድ",
    "delete": "ሰርዝ",
    "deleteTitle": "አስታውስ ሰርዝ",
    "deleteConfirm": "ይህ አስታውስ በሙሉ ይሰረዝ።",
    "deleteRecurringTitle": "የተደጋጋሚ አስታውስ ሰርዝ",
    "deleteRecurringMessage": "ይህን ክስተት መውጣት ወይም ሙሉ ተደጋጋሚ ሰርዝ?",
    "deleteThisOccurrence": "ይህን ክስተት ተው",
    "deleteEntireSeries": "ሙሉ ተደጋጋሚ ሰርዝ",
    "done": "ተጠናቀቀ",
    "markDone": "እንደተጠናቀቀ ምልክት አድርግ",
    "undo": "አስተካክል",
    "undoPrompt": "እንደገና እንዲሰራ ይፈልጋሉ? አሁን አስተካክል።",
    "recurring": "የተደጋጋሚ",
    "nextRun": "ቀጣይ እንቅስቃሴ",
    "oneTime": "አንድ ጊዜ",
    "pending": "በመጠበቅ ላይ",
    "sent": "ተልኳል",
    "paused": "ቆሟል",
    "active": "እየሰራ",
    "snoozed": "አስቆም",
    "localTime": "በአካባቢዎ ሰዓት ይታያል",
    "recurrence": "የመደገፊያ ጊዜ",
    "created": "ተፈጥሯል",
    "tags": "መለያዎች",
    "fireCount": "የተነሳ ጊዜያት",
    "actions": "እርምጃዎች",
    "none": "አልተገኘም",
    "snoozeFailed": "አስታውስን ማስቆም አልተሳካም",
    "pauseFailed": "አስታውስን ማቆም አልተሳካም",
    "resumeFailed": "አስታውስን እንደገና መጀመር አልተሳካም",
    "skipFailed": "አስታውስን ማለፍ አልተሳካም",
    "doneFailed": "አስታውስን እንደተጠናቀቀ ማስመዝገብ አልተሳካም",
    "undoFailed": "የአስታውስ ሁኔታ መመለስ አልተሳካም",
    "deleteFailed": "አስታውስን ማስወገድ አልተሳካም",
    "rescheduleTitle": "እንደገና ማሰራት?",
    "rescheduleMsg": "ይህ አስታውስ ያልተጠናቀቀ ነው። እንደገና ማሰራት ይፈልጋሉ?",
    "reschedule15": "በ15 ደቂቃ",
    "reschedule60": "በ1 ሰዓት",
    "keepOverdue": "እንደሆነ ይቆይ"
  },
  "onboarding": {
    "slide1Title": "እንኳን ወደ FishMemory በደህና መጡ",
    "slide1Sub": "የግል አስታውሰኛ አገልጋይዎ — በ WhatsApp የተነሳ እና ለእጅዎ ተሰርቷል።",
    "slide2Title": "በተፈጥሮ ውይይት አድርግ",
    "slide2Sub": "እንደምትሰማው አስታውሶችን ያስገቡ: \"ነገ 3 ሰዓት እናቱን ለመደወል አስታውስ\" — እኛ ቀሪውን እንከታተላለን።",
    "slide3Title": "አንዳች አትጎድል",
    "slide3Sub": "በጊዜያዊ ማስታወቂያዎች ይተጋሉ፣ በመለያዎች ያደርጉ እና ለእንደሚጠበቅ ሁሉ ተከታትሉ።",
    "getStarted": "ጀምር",
    "next": "ቀጣይ",
    "firstReminderTitle": "የመጀመሪያ አስታውስ ፍጠር!",
    "firstReminderHint": "እንደምንም ይሞክሩ:",
    "firstReminderExample": "ነገ 9 ሰዓት ውሃ ለመጠጥ አስታውስ",
    "gotIt": "አረጋግጧል!",
    "notifRationaleTitle": "በጊዜው ቆይ",
    "notifRationaleBody": "FishMemory በጊዜው ለማሳወቅ ማስታወቂያዎች ያስፈልጋል። እርስዎ የፈጠሩትን አስታውሶች ብቻ ማሳወቂያ ያገኛሉ።",
    "notifRationaleAllow": "ማስታወቂያዎችን አንቀሳቅስ",
    "notifRationaleLater": "ምናልባት በኋላ",
    "swipeHint": "ለፈጣን እርምጃዎች ቀኝ አስቀምጥ →",
    "calendarDragHint": "ለማስፋፋት አስንቀሳ ↕"
  }
}
